import _slicedToArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _regeneratorRuntime from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _defineProperty from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectSpread from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import { combineURLs, typeStreamID } from './utils.js';
import { Document } from './document.js';
import { fetchJson, StreamUtils, SyncOptions } from '@ceramicnetwork/common';
import { TileDocument } from '@ceramicnetwork/stream-tile';
import { Caip10Link } from '@ceramicnetwork/stream-caip10-link';
import { StreamRef } from '@ceramicnetwork/streamid';
import { RemotePinApi } from './remote-pin-api.js';
var API_PATH = '/api/v0';
var CERAMIC_HOST = 'http://localhost:7007';
export var DEFAULT_CLIENT_CONFIG = {
  syncInterval: 5000
};
var DEFAULT_APPLY_COMMIT_OPTS = {
  anchor: true,
  publish: true,
  sync: SyncOptions.PREFER_CACHE
};
var DEFAULT_CREATE_FROM_GENESIS_OPTS = {
  anchor: true,
  publish: true,
  sync: SyncOptions.PREFER_CACHE
};
var DEFAULT_LOAD_OPTS = {
  sync: SyncOptions.PREFER_CACHE
};
export var CeramicClient = /*#__PURE__*/function () {
  function CeramicClient() {
    var _this$_streamConstruc;
    var apiHost = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : CERAMIC_HOST;
    var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    _classCallCheck(this, CeramicClient);
    this._config = _objectSpread(_objectSpread({}, DEFAULT_CLIENT_CONFIG), config);
    this._apiUrl = combineURLs(apiHost, API_PATH);
    this._streamCache = new Map();
    this.context = {
      api: this
    };
    this.pin = new RemotePinApi(this._apiUrl);
    this._streamConstructors = (_this$_streamConstruc = {}, _defineProperty(_this$_streamConstruc, TileDocument.STREAM_TYPE_ID, TileDocument), _defineProperty(_this$_streamConstruc, Caip10Link.STREAM_TYPE_ID, Caip10Link), _this$_streamConstruc);
  }
  _createClass(CeramicClient, [{
    key: "did",
    get: function get() {
      return this.context.did;
    },
    set: function set(did) {
      this.context.did = did;
    }
  }, {
    key: "createStreamFromGenesis",
    value: function () {
      var _createStreamFromGenesis = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(type, genesis) {
        var opts,
          stream,
          found,
          _args = arguments;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              opts = _args.length > 2 && _args[2] !== undefined ? _args[2] : {};
              opts = _objectSpread(_objectSpread({}, DEFAULT_CREATE_FROM_GENESIS_OPTS), opts);
              _context.next = 4;
              return Document.createFromGenesis(this._apiUrl, type, genesis, opts, this._config.syncInterval);
            case 4:
              stream = _context.sent;
              found = this._streamCache.get(stream.id.toString());
              if (!found) {
                _context.next = 11;
                break;
              }
              if (!StreamUtils.statesEqual(stream.state, found.state)) found.next(stream.state);
              return _context.abrupt("return", this.buildStream(found));
            case 11:
              this._streamCache.set(stream.id.toString(), stream);
              return _context.abrupt("return", this.buildStream(stream));
            case 13:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function createStreamFromGenesis(_x, _x2) {
        return _createStreamFromGenesis.apply(this, arguments);
      }
      return createStreamFromGenesis;
    }()
  }, {
    key: "loadStream",
    value: function () {
      var _loadStream = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(streamId) {
        var opts,
          streamRef,
          stream,
          _args2 = arguments;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              opts = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {};
              opts = _objectSpread(_objectSpread({}, DEFAULT_LOAD_OPTS), opts);
              streamRef = StreamRef.from(streamId);
              stream = this._streamCache.get(streamRef.baseID.toString());
              if (!stream) {
                _context2.next = 9;
                break;
              }
              _context2.next = 7;
              return stream._syncState(streamRef, opts);
            case 7:
              _context2.next = 13;
              break;
            case 9:
              _context2.next = 11;
              return Document.load(streamRef, this._apiUrl, this._config.syncInterval, opts);
            case 11:
              stream = _context2.sent;
              this._streamCache.set(stream.id.toString(), stream);
            case 13:
              return _context2.abrupt("return", this.buildStream(stream));
            case 14:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function loadStream(_x3) {
        return _loadStream.apply(this, arguments);
      }
      return loadStream;
    }()
  }, {
    key: "multiQuery",
    value: function () {
      var _multiQuery = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(queries, timeout) {
        var _this = this;
        var queriesJSON, results;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              queriesJSON = queries.map(function (q) {
                return _objectSpread(_objectSpread({}, q), {}, {
                  streamId: typeof q.streamId === 'string' ? q.streamId : q.streamId.toString()
                });
              });
              _context3.next = 3;
              return fetchJson(this._apiUrl + '/multiqueries', {
                method: 'post',
                body: _objectSpread({
                  queries: queriesJSON
                }, {
                  timeout: timeout
                })
              });
            case 3:
              results = _context3.sent;
              return _context3.abrupt("return", Object.entries(results).reduce(function (acc, e) {
                var _e = _slicedToArray(e, 2),
                  k = _e[0],
                  v = _e[1];
                var state = StreamUtils.deserializeState(v);
                var stream = new Document(state, _this._apiUrl, _this._config.syncInterval);
                acc[k] = _this.buildStream(stream);
                return acc;
              }, {}));
            case 5:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function multiQuery(_x4, _x5) {
        return _multiQuery.apply(this, arguments);
      }
      return multiQuery;
    }()
  }, {
    key: "loadStreamCommits",
    value: function loadStreamCommits(streamId) {
      var effectiveStreamId = typeStreamID(streamId);
      return Document.loadStreamCommits(effectiveStreamId, this._apiUrl);
    }
  }, {
    key: "applyCommit",
    value: function () {
      var _applyCommit = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(streamId, commit) {
        var opts,
          effectiveStreamId,
          document,
          fromCache,
          _args4 = arguments;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              opts = _args4.length > 2 && _args4[2] !== undefined ? _args4[2] : {};
              opts = _objectSpread(_objectSpread({}, DEFAULT_APPLY_COMMIT_OPTS), opts);
              effectiveStreamId = typeStreamID(streamId);
              _context4.next = 5;
              return Document.applyCommit(this._apiUrl, effectiveStreamId, commit, opts, this._config.syncInterval);
            case 5:
              document = _context4.sent;
              fromCache = this._streamCache.get(effectiveStreamId.toString());
              if (!fromCache) {
                _context4.next = 12;
                break;
              }
              fromCache.next(document.state);
              return _context4.abrupt("return", this.buildStream(document));
            case 12:
              this._streamCache.set(effectiveStreamId.toString(), document);
              return _context4.abrupt("return", this.buildStream(document));
            case 14:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function applyCommit(_x6, _x7) {
        return _applyCommit.apply(this, arguments);
      }
      return applyCommit;
    }()
  }, {
    key: "requestAnchor",
    value: function () {
      var _requestAnchor = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(streamId) {
        var opts,
          _yield$fetchJson,
          anchorStatus,
          _args5 = arguments;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              opts = _args5.length > 1 && _args5[1] !== undefined ? _args5[1] : {};
              opts = _objectSpread(_objectSpread({}, DEFAULT_LOAD_OPTS), opts);
              _context5.next = 4;
              return fetchJson("".concat(this._apiUrl, "/streams/").concat(streamId.toString(), "/anchor"), {
                method: 'post',
                body: {
                  opts: opts
                }
              });
            case 4:
              _yield$fetchJson = _context5.sent;
              anchorStatus = _yield$fetchJson.anchorStatus;
              return _context5.abrupt("return", anchorStatus);
            case 7:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function requestAnchor(_x8) {
        return _requestAnchor.apply(this, arguments);
      }
      return requestAnchor;
    }()
  }, {
    key: "addStreamHandler",
    value: function addStreamHandler(streamHandler) {
      this._streamConstructors[streamHandler.name] = streamHandler.stream_constructor;
    }
  }, {
    key: "findStreamConstructor",
    value: function findStreamConstructor(type) {
      var constructor = this._streamConstructors[type];
      if (constructor) {
        return constructor;
      } else {
        throw new Error("Failed to find constructor for stream ".concat(type));
      }
    }
  }, {
    key: "buildStream",
    value: function buildStream(stream) {
      var streamConstructor = this.findStreamConstructor(stream.state.type);
      return new streamConstructor(stream, this.context);
    }
  }, {
    key: "setDID",
    value: function () {
      var _setDID = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(did) {
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              this.context.did = did;
            case 1:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function setDID(_x9) {
        return _setDID.apply(this, arguments);
      }
      return setDID;
    }()
  }, {
    key: "getSupportedChains",
    value: function () {
      var _getSupportedChains = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        var _yield$fetchJson2, supportedChains;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              if (!this._supportedChains) {
                _context7.next = 2;
                break;
              }
              return _context7.abrupt("return", this._supportedChains);
            case 2:
              _context7.next = 4;
              return fetchJson(this._apiUrl + '/node/chains');
            case 4:
              _yield$fetchJson2 = _context7.sent;
              supportedChains = _yield$fetchJson2.supportedChains;
              this._supportedChains = supportedChains;
              return _context7.abrupt("return", supportedChains);
            case 8:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
      function getSupportedChains() {
        return _getSupportedChains.apply(this, arguments);
      }
      return getSupportedChains;
    }()
  }, {
    key: "close",
    value: function () {
      var _close = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              Array.from(this._streamCache).map(function (_ref) {
                var _ref2 = _slicedToArray(_ref, 2),
                  stream = _ref2[1];
                stream.complete();
              });
              this._streamCache.clear();
            case 2:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this);
      }));
      function close() {
        return _close.apply(this, arguments);
      }
      return close;
    }()
  }]);
  return CeramicClient;
}();